import React from 'react';
import { Fade } from 'react-awesome-reveal';

function Reviews() {
    // Helper function to calculate time ago from date
    const getTimeAgo = (datePosted) => {
        const now = new Date();
        const posted = new Date(datePosted);
        const diffInMs = now - posted;
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        const diffInWeeks = Math.floor(diffInDays / 7);
        const diffInMonths = Math.floor(diffInDays / 30);
        const diffInYears = Math.floor(diffInDays / 365);

        if (diffInYears > 0) {
            return diffInYears === 1 ? "a year ago" : `${diffInYears} years ago`;
        } else if (diffInMonths > 0) {
            return diffInMonths === 1 ? "a month ago" : `${diffInMonths} months ago`;
        } else if (diffInWeeks > 0) {
            return diffInWeeks === 1 ? "a week ago" : `${diffInWeeks} weeks ago`;
        } else if (diffInDays > 0) {
            return diffInDays === 1 ? "a day ago" : `${diffInDays} days ago`;
        } else {
            return "today";
        }
    };

    const reviewsData = [
        {
            name: "Sanam Sarwar",
            datePosted: "2025-07-10", // About a week ago from mid-December 2024
            rating: 5,
            text: "We recently did a 2 week intensive with Svenje for our 11 month old daughter and the results were amazing. Our little one got much stronger than before 💪🏼 Svenje is very gentle with kids and is the best in this field."
        },
        {
            name: "Julie Padgett",
            datePosted: "2025-06-17", // About a month ago
            rating: 5,
            text: "Svenje is wonderful! Friendly and super knowledgeable for all my aches and pains! I've been treated by her (as an adult) and she's treated 2 of my kids as well! Highly recommend!"
        },
        {
            name: "Elaine Greene",
            datePosted: "2025-06-17", // About a month ago
            rating: 5,
            text: "As the mom of two high risk sports addicted boys I can confidently say that Peak and Pine Physio keeps them going. One of them is adverse to any medical help and Svenje has made him feel so at home he is excited to go for his treatments and do his homework exercises."
        },
        {
            name: "Melissa Boisvenue",
            datePosted: "2025-06-17", // About a month ago
            rating: 5,
            text: "Svenje is one of a kind with kids. Would highly recommend for both adult and pediatric patients."
        }
    ];

    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, index) => (
            <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
                ★
            </span>
        ));
    };

    return (
        <div className="reviews container-fluid py-5">
            <Fade triggerOnce>
                <h2 className="service-title mt-3 mb-5 paediatric-title">CLIENT REVIEWS</h2>
            </Fade>
            
            <div className="container">
                <div className="row">
                    {reviewsData.map((review, index) => (

                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 justify-content-center mb-3 d-flex">
                                <div className="review-card">
                                    <div className="review-header">
                                        <div className="review-author">
                                            <h4 className="author-name">{review.name}</h4>
                                            <span className="review-time">{getTimeAgo(review.datePosted)}</span>
                                        </div>
                                        <div className="rating">
                                            {renderStars(review.rating)}
                                        </div>
                                    </div>
                                    <p className="review-text">{review.text}</p>
                                </div>
                            </div>

                    ))}
                </div>
            </div>
        </div>
    );
}

export default Reviews;
